import { ErrorType } from "../Redux/store";

const apiErrorHelper = (error: any): ErrorType => {
  if (error?.response?.data?.message) {
    return {
      error: error?.response?.data?.error,
      message: error?.response?.data?.message,
      response: error?.response?.data,
      status: error?.response?.status,
    };
  } else {
    return {
      error: "Something went wrong",
      message: "Something went wrong",
      response: error,
      status: 500,
    };
  }
};

export default apiErrorHelper;
